<template>
<div>
        <div class="form-group row">

                <div class="col-lg-8">
            
                   <DropFiles
                        :file="validate_file(item.model1)"
                        :module_id="item._id"
                        @onUploaded="updateModel1"
                        @onRemoved="removeModel1"
                        :accept="'.fbx'"   
                        module_type="event-hall"
                        asset_type="exhibition_hall_background_image"
                        @onError="errCb"
                    >
  <template #header>
    <label>3D Model 1 (Should be in FBX format and Size nnot more than 10 MB)</label>
  </template>
  <template #tooltip>
    <VTooltip style="display:inline-block">
      <i class="fa fa-info-circle" style="font-size:16px"></i>
      <template #popper>
        <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
      </template>
    </VTooltip>
  </template>
</DropFiles>


                </div>
       </div>
       <div class="form-group row">
     
            <div class="col-lg-8">
        
                <DropFiles   DropFiles :file="validate_file(item.model2)" 
                        :module_id="item._id" 
                        @onUploaded="updateModel2" 
                        @onRemoved="removeModel2"
                         :accept="'.fbx'"   
                        module_type="event-hall" 
                        asset_type="exhibition_hall_background_image"  
                        @onError="errCb">

            <template #header>
                <label>3D Model 2 (Should be in FBX format and Size not more than 10 MB)</label>
            </template>
            <template #tooltip>
                <VTooltip style="display:inline-block">
                <i class="fa fa-info-circle" style="font-size:16px"></i>
                <template #popper>
                    <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                </template>
                </VTooltip>
            </template>
            </DropFiles>

            </div>
        </div>



    

    

    
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import  configsize  from "@/config/configsize";
  
export default {
    name: "3DModelTab",
    data() {
        
       
    },
    created() {
      this.fetchEventData(this.$route.params.event_id);
      //this.fetchConfiguration();
     },
    computed: {
        ...mapGetters("EventHallsSingle", [
            "item",
            "loading",
            "event_type",
            "skyboxes",
            "environments"
        ]),
        ...mapGetters("EventsSingle", {"eventItem": "item"}),
        //...mapGetters('ConfigurationsSingle', {'projectConfiguration':'item'}),
    },
    methods: {
        ...mapActions("EventsSingle",{"fetchEventData":"fetchData"}),
       ...mapActions("EventHallsSingle", [
            "setModel1",
            "setModel2"
        
        ]),
       // ...mapActions('ConfigurationsSingle', {'fetchConfiguration': 'fetchData'}),      
    
        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
            return null;
        },
      

       updateModel1(info, data) {
            const key = _.get(this.item.model1, 'key', null);
            const size = _.get(info, 'file.size', 0); // size in bytes
            console.log("2:--Checking FBX size ********size", size);

            const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
            if (size > maxSize) {
                this.showVideoError();
                return; // stop further processing
            }

            let fileKey = data.data.key ? data.data.key : data.data.Key;
            const extension = fileKey.split('.').pop();
            if(['fbx'].includes(extension) ==false){
                 this.errCb();
                return;
                                
            }

            this.setModel1({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
         updateModel2(info, data) {
            const key = _.get(this.item.model2, 'key', null);
            const size = _.get(info, 'file.size', 0); // size in bytes
            console.log("2:--Checking FBX size ********size", size);

            const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
            if (size > maxSize) {
                this.showVideoError();
                return; // stop further processing
            }

            let fileKey = data.data.key ? data.data.key : data.data.Key;
            const extension = fileKey.split('.').pop();
            if(['fbx'].includes(extension) ==false){
                 this.errCb();
                return;
                                
            }
            this.setModel2({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy: info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeModel1(e) {
            this.setModel1(null);
        },
        removeModel2(e) {
            this.setModel2(null);
        },
       
        errCb(e){
            this.$flashMessage.show({
                group : 'event_hall_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        },
        showCbError(e){
            this.$flashMessage.show({
                group : 'event_hall_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded document should be less than 30 MB.</li></ul>"

            })
        },
        showVideoError(e){
            this.$flashMessage.show({
                group : 'event_hall_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Uploaded video should be less than 10 MB.</li></ul>"

            })
        }
        
       
    }
}
</script>

<style scoped>

</style>